import {ym} from './ym'
import {getAnalyticsId} from './getAnalyticsId'
import {createPathNameWatcher} from '../shared/createPathNameWatcher'

try {
  let referer = window.location.origin + window.location.pathname
  let timeoutId = -1

  /** https://yandex.ru/support/metrica/code/counter-spa-setup.html */
  createPathNameWatcher(() => {
    try {
      clearTimeout(timeoutId)

      // Дебаунсим отправку хита чтобы не замусоривать метрику фантомными переходами, которые случаются из-за редиректов
      // в продуктовых метриках нам это не нужно (в RUM нужно а тут нет)
      timeoutId = Number(
        setTimeout(() => {
          try {
            ym(getAnalyticsId(), 'hit', window.location.origin + window.location.pathname, {params: {referer}})
            referer = window.location.origin + window.location.pathname
          } catch (error) {
            console.error(error)
          }
        }, 100)
      )
    } catch (error) {
      console.error(error)
    }
  })
} catch (error) {
  console.error(error)
}
